import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo.png"; // reemplaza con tu logo

function Header() {
  const location = useLocation();

  return (
    <header>
      <div
        className="header-container"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div className="logo" style={{ height: "50px" }}>
          <Link to="/">
            <img src={logo} alt="Qdamos Logo" style={{ height: "50px" }} />
          </Link>
        </div>
        <nav className="nav-menu">
          <ul>
            <li>
              <Link
                to="/"
                className={location.pathname === "/" ? "active" : ""}
              >
                Inicio
              </Link>
            </li>
            <li>
              <Link
                to="/menu"
                className={location.pathname === "/menu" ? "active" : ""}
              >
                Menú
              </Link>
            </li>
            <li>
              <Link
                to="/cartaVinos"
                className={location.pathname === "/cartaVinos" ? "active" : ""}
              >
                Carta de Vinos
              </Link>
            </li>
            <li>
              <Link
                to="/eventos"
                className={location.pathname === "/eventos" ? "active" : ""}
              >
                Eventos
              </Link>
            </li>
            <li>
              <Link
                to="/galeria"
                className={location.pathname === "/galeria" ? "active" : ""}
              >
                Galería
              </Link>
            </li>
            <li>
              <Link
                to="/contacto"
                className={location.pathname === "/contacto" ? "active" : ""}
              >
                Contacto
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
